import { render } from "./Branches.vue?vue&type=template&id=1c39682a&scoped=true&ts=true"
import script from "./Branches.vue?vue&type=script&lang=ts"
export * from "./Branches.vue?vue&type=script&lang=ts"

import "./Branches.vue?vue&type=style&index=0&id=1c39682a&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c39682a"]])

export default __exports__